import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class MaterialIconRegistryService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  icons: string[] = ['ticket', 'qrcode', 'access_time', 'calendar_today', 'directions'];

  constructor() {
    this.registerIcons();
  }

  private registerIcons(): void {
    this.icons.forEach(iconName => {
      this.iconRegistry.addSvgIcon(
        iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${iconName}.svg`)
      );
    });
  }
}
